import Hero from './Hero';
import TradingCards from './TradingCards';

const Home = () => {
    return (
        <>
            <Hero />
            <TradingCards />
        </>
    );
};

export default Home;
